export var PriceAdjustmentType;
(function (PriceAdjustmentType) {
    PriceAdjustmentType["DISCOUNT"] = "DISCOUNT";
    PriceAdjustmentType["SURCHARGE"] = "SURCHARGE";
})(PriceAdjustmentType || (PriceAdjustmentType = {}));
